// extracted by mini-css-extract-plugin
export var descriptionText = "marketo-form-module--descriptionText--d7f55";
export var disclaimer = "marketo-form-module--disclaimer--06d21";
export var eyebrowText = "marketo-form-module--eyebrowText--50c72";
export var headerContainer = "marketo-form-module--headerContainer--fb552";
export var headerText = "marketo-form-module--headerText--c6f17";
export var marketoFormContainer = "marketo-form-module--marketoFormContainer--25662";
export var popupHeaderText = "marketo-form-module--popupHeaderText--0af38";
export var resourceFormContainer = "marketo-form-module--resourceFormContainer--5d302";
export var thankYouMessageContainer = "marketo-form-module--thankYouMessageContainer--7e174";